import { render, staticRenderFns } from "./ManageFlowMobile.vue?vue&type=template&id=e12c0680&"
import script from "./ManageFlowMobile.vue?vue&type=script&lang=js&"
export * from "./ManageFlowMobile.vue?vue&type=script&lang=js&"
import style0 from "./ManageFlowMobile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e12c0680')) {
      api.createRecord('e12c0680', component.options)
    } else {
      api.reload('e12c0680', component.options)
    }
    module.hot.accept("./ManageFlowMobile.vue?vue&type=template&id=e12c0680&", function () {
      api.rerender('e12c0680', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/mobile/ManageFlowMobile.vue"
export default component.exports